import React, { createContext, useEffect, useState } from "react";
import theme from "./utils/theme";
import { ThemeProvider } from "@mui/material";
import { Loader } from "./controls";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import "./styles/App.scss";
import "./styles/Style.scss";
import SiteRoute from "./pages/SiteRoute";
import { Login, Forgot } from "./components/auth";
import { API, action, controller } from "./api/api";
import Toast from "layout/Toast";
import { lsSave } from "hooks";
import { CACHE_VERSION } from "config/version";

export const AppContext = createContext({});

const App = () => {
  const [loader, setLoader] = useState(false);
  const [authUser, setAuthUser] = useState();
  const [settings, setSettings] = useState({});
  const [access, setAccess] = useState({});

  // ----- Clear browser local storage data base on the version changes -----
  useEffect(() => {
    const savedVersion = localStorage.getItem("cache_version");
    if (savedVersion !== CACHE_VERSION) {
      console.log("Cache version changed, clearing localStorage");
      localStorage.clear();
      localStorage.setItem("cache_version", CACHE_VERSION);
    }
  }, []);

  // Fetch auth user
  useEffect(() => {
    const fetchAuthUser = async () => {
      try {
        await API(controller.Auth + action.GetAuthUser).get((res, err) => {
          if (res && res.status === 200 && res.result) {
            setAuthUser(res.result);
          } else setAuthUser(null);
        });
      } catch (error) {
        console.error("Auth user fetch error:", error);
        setAuthUser(null);
      }
    };
    fetchAuthUser();
  }, []);

  useEffect(() => {
    if (authUser && authUser.id) {
      // Get Settings
      API(controller.Org + action.GetSettings).get((res) => {
        if (res?.status === 200) {
          setSettings({ ...res?.settings });
          setAccess({ ...res?.featureAccess });
        }
      });

      // Get Active Register
      API(controller.SellReg + action.GetCashierOpenReg).get((res) => {
        if (res && res.status === 200) lsSave("activeReg", { ...res?.result });
      });
    }
    return () => {};
  }, [authUser]);

  return (
    <ThemeProvider theme={theme}>
      <AppContext.Provider
        value={{
          loader,
          setLoader,
          authUser,
          setAuthUser,
          settings,
          access,
        }}
      >
        <Loader show={loader} />
        <Router>
          <Routes>
            <Route
              path="/*"
              element={authUser ? <SiteRoute /> : !loader && <Auth />}
            />
          </Routes>
        </Router>
        <Toast />
      </AppContext.Provider>
    </ThemeProvider>
  );
};

const Auth = () => (
  <>
    <Routes>
      <Route path="/" element={<Navigate to="auth" />} />
      <Route path="/auth">
        <Route path="forgot" element={<Forgot />} />
        <Route index element={<Login />} />
      </Route>
    </Routes>
  </>
);

export default App;
